// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AXWv97zyMHpWD8 {
  box-sizing: border-box;
  width: 100vw;
  max-height: calc(95vh - 96px);
  margin: var(--ds-space-0, 0) auto;
  padding: var(--ds-space-300, 24px);
}
@media (max-width: 750px) {
  .AXWv97zyMHpWD8 {
    width: auto;
    padding: var(--ds-space-300, 24px) var(--ds-space-300, 24px) var(--ds-space-100, 8px) var(--ds-space-300, 24px);
  }
}
.AXWv97zyMHpWD8.ljMAPsGEq5oWE7 {
  max-width: 800px;
  overflow: auto;
}
.AXWv97zyMHpWD8.GHQrnnXUeb_sxV,
.AXWv97zyMHpWD8.HvEPs_7JBpD_Jt {
  max-width: 480px;
}
.AXWv97zyMHpWD8.NX2LEhX1cU7aVE {
  max-width: 600px;
}
.AXWv97zyMHpWD8.GDMXkmSSZsSELB {
  max-width: 1130px;
  overflow: auto;
}
.AXWv97zyMHpWD8.tocxtr63asCnoL {
  max-width: 692px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalWrapper": `AXWv97zyMHpWD8`,
	"trial-ended-plan-selection": `ljMAPsGEq5oWE7`,
	"payment-standard": `GHQrnnXUeb_sxV`,
	"payment-premium": `HvEPs_7JBpD_Jt`,
	"free-selection-information": `NX2LEhX1cU7aVE`,
	"plan-comparison": `GDMXkmSSZsSELB`,
	"closed-boards": `tocxtr63asCnoL`
};
export default ___CSS_LOADER_EXPORT___;
